export default __webpack_public_path__ + "static/media/besoins.cac2860e.svg";